import {useQuery} from "@tanstack/react-query";
import { useScanContext } from "./scan-model/ScanContext";
import {useAtomValue, useSetAtom} from "jotai";
import {ApiAtom} from "../../common-process/1-metl-connection/MetlConnectionProperties.ts";
import {AnalysisOptionsAtom} from "../2-option-selection/AnalysisOptions.ts";
import {performScan} from "./scan-operations/0-BaseScan.ts";
import { Button } from "@matillion/component-library";
import {ScanningDisplay} from "./scan-display/ScanningDisplay.tsx";
import {ScanResultDisplay, ScanResultErrorWarning} from "./scan-result-display/ScanResultDisplay.tsx";
import {ScanAtom} from "./ScanAtom.tsx";
import {useClearUpload} from "../4-upload-results/useClearUpload.tsx";
import {useStepContext} from "../../components/stepper/StepContext.ts";

export function ScanWidget() {
    const api = useAtomValue(ApiAtom)
    const options = useAtomValue(AnalysisOptionsAtom)
    const { lock: lockStep } = useStepContext()
    const [scanContext, scanDisplayInfo] = useScanContext()
    const setScanResult = useSetAtom(ScanAtom)
    const clearUpload = useClearUpload()
    const query = useQuery({
        queryKey: ["scan", api?.id ?? "unknown", "options", options.id],
        queryFn: () => {
            return lockStep(async () => {
                const result = await performScan(scanContext)
                setScanResult(result)
                await clearUpload()
                return result
            })
        },
        enabled: false,
        gcTime: Infinity,
        staleTime: Infinity,
        retry: false
    })

    if(!query.data && !query.isLoading && !query.isError && !query.isFetching) {
        return <div>
            <h2>Scan METL</h2>
            <Button onClick={() => query.refetch()}>Scan</Button>
        </div>
    }

    return <div>
        <h2>Scan METL</h2>
        <div>
            <h2>Scan Progress</h2>
            <ScanningDisplay display={scanDisplayInfo} />
        </div>
        {query.isError && <ScanResultErrorWarning
            errors={scanContext.scanErrors}
            fatalError={query.error}
        />}
        {query.data && <ScanResultDisplay result={query.data} />}
    </div>
}